import React from 'react';
import { CopyIcon } from 'lucide-react';
import { copyToClipboard } from '../../utils/clipboard';

export function CopyChip({ icon: Icon, value, label, small = false }) {
  if (!value) return null;
  return (
    <button
      type="button"
      onClick={() => copyToClipboard(value, label)}
      aria-label={`Copy ${label} ${value}`}
      className={`tw-group/copy tw-inline-flex tw-max-w-full tw-items-center tw-gap-1.5 tw-rounded-md tw-px-1.5 tw-text-neutral-500 tw-transition-colors tw-duration-100 hover:tw-bg-sand-50 hover:tw-text-neutral-900 ${small ? 'tw-py-px tw-text-xs' : 'tw-py-0.5 tw-text-sm'}`}>
      <Icon className={`${small ? 'tw-h-3 tw-w-3' : 'tw-h-3.5 tw-w-3.5'} tw-shrink-0 tw-text-neutral-400`} aria-hidden />
      <span className="tw-truncate tw-whitespace-nowrap">{value}</span>
      <CopyIcon className="tw-h-3 tw-w-3 tw-shrink-0 tw-text-neutral-400 tw-opacity-0 tw-transition-opacity tw-duration-150 group-hover/copy:tw-opacity-100" aria-hidden />
    </button>
  );
}
